<acabim-card cardHeading="Your Data Export Requests"
             [cardContent]="cardContent"
             [isCollapsible]="false"
             *ngIf="projectApiService.selectedProjectId$ | async; else noProject">
</acabim-card>
<ng-template #cardContent>
    <acabim-datatable [dataSources]="dataExportDataSource"></acabim-datatable>
</ng-template>

<ng-template #noProject>
    <div class="cas-error">Please select a project to view its model data</div>
</ng-template>
